/**
 * Находит элемент с локальной сеткой под указанной позицией
 *
 * @param stage - Сцена Konva
 * @param worldX - X координата в мировых координатах
 * @param worldY - Y координата в мировых координатах
 * @param boardState - Состояние доски
 * @returns Элемент с локальной сеткой или null
 */
export function findElementWithLocalGrid(stage, worldX, worldY, boardState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!stage)
        return null;
    // Ищем элемент, который содержит эту точку и имеет локальную сетку
    for (const layer of boardState.layers || []) {
        if (!layer.visible)
            continue;
        for (const el of layer.elements || []) {
            const elX = (_b = (_a = el.props) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0;
            const elY = (_d = (_c = el.props) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0;
            const elW = (_f = (_e = el.props) === null || _e === void 0 ? void 0 : _e.w) !== null && _f !== void 0 ? _f : 0;
            const elH = (_h = (_g = el.props) === null || _g === void 0 ? void 0 : _g.h) !== null && _h !== void 0 ? _h : 0;
            // Проверяем, находится ли точка внутри элемента
            if (worldX >= elX && worldX <= elX + elW && worldY >= elY && worldY <= elY + elH) {
                if ((_k = (_j = el.props) === null || _j === void 0 ? void 0 : _j.localGrid) === null || _k === void 0 ? void 0 : _k.enabled) {
                    return el;
                }
            }
        }
    }
    return null;
}
/**
 * Вычисляет расстояние между двумя точками
 *
 * @param startPoint - Начальная точка в мировых координатах
 * @param endPoint - Конечная точка в мировых координатах
 * @param elementWithGrid - Элемент с локальной сеткой (если начальная точка над ним)
 * @returns Объект с расстоянием и единицей измерения
 */
export function calculateRulerDistance(startPoint, endPoint, elementWithGrid) {
    var _a, _b, _c;
    // Вычисляем расстояние в пикселях
    const dx = endPoint.x - startPoint.x;
    const dy = endPoint.y - startPoint.y;
    const distancePx = Math.sqrt(dx * dx + dy * dy);
    // Если начальная точка над элементом с локальной сеткой
    if (elementWithGrid && ((_b = (_a = elementWithGrid.props) === null || _a === void 0 ? void 0 : _a.localGrid) === null || _b === void 0 ? void 0 : _b.enabled)) {
        const gridSize = (_c = elementWithGrid.props.localGrid.size) !== null && _c !== void 0 ? _c : 50;
        const distanceCells = distancePx / gridSize;
        return { distance: distanceCells, unit: 'cells' };
    }
    // Иначе возвращаем расстояние в пикселях
    return { distance: distancePx, unit: 'px' };
}
